module.exports = __webpack_public_path__ + "img/03.06b8eb77.jpg";